import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getProfileStats, updateProfile } from '../services/server-api/api';
import LoadingIndicator from '../pages/general/LoadingIndicator';
import { TbDeviceFloppy } from 'react-icons/tb';
import '../../assets/css/profile.css';

const Profile = () => {
  const [profileData, setProfileData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Edit profile states
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [profileError, setProfileError] = useState('');
  const [profileSuccess, setProfileSuccess] = useState('');

  const getInitials = () => {
    if (!profileData?.user) return '?';
    const first = profileData.user.firstName?.charAt(0) || '';
    const last = profileData.user.lastName?.charAt(0) || '';
    return (first + last).toUpperCase() || profileData.user.username?.charAt(0).toUpperCase() || '?';
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchProfile = async () => {
      try {
        const data = await getProfileStats();
        setProfileData(data);
        setFirstName(data.user.firstName);
        setLastName(data.user.lastName);
        setLoading(false);
      } catch (err) {
        console.error('Profile fetch error: ', err);
        if (err.response?.status === 401) {
          setError('You need to log in to view this page.');
          localStorage.removeItem('token');
          navigate('/login');
        } else {
          setError('Failed to load profile');
          setLoading(false);
        }
      }
    };

    fetchProfile();
  }, [navigate]);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    setProfileError('');
    setProfileSuccess('');

    if (!firstName.trim() || !lastName.trim()) {
      setProfileError('First name and last name are required');
      return;
    }

    try {
      await updateProfile({ firstName, lastName });
      setProfileSuccess('Profile updated successfully!');

      const data = await getProfileStats();
      setProfileData(data);
      
      setTimeout(() => setProfileSuccess(''), 3000);
    } catch (err) {
      setProfileError(err.response?.data?.error || 'Failed to update profile');
    }
  };

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  const { user } = profileData || {};

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-header-content">
          <div className="profile-avatar">{getInitials()}</div>
          <div className="profile-info-header">
            <h1>{user?.firstName} {user?.lastName}</h1>
            <div className="profile-meta">
              <div className="profile-meta-item">
                <span>✉</span>
                <span>{user?.email}</span>
              </div>
              <div className="profile-meta-item">
                <span>👤</span>
                <span>@{user?.username}</span>
              </div>
            </div>
            <div className="profile-role-badge">
              {user?.roleName || 'User'}
            </div>
          </div>
        </div>
      </div>

      <div className="profile-grid">
        <div className="profile-card">
          <h2>
            Edit Names
          </h2>
          {profileSuccess && <div className="success-message">{profileSuccess}</div>}
          {profileError && <div className="error-message">{profileError}</div>}

          <div className="profile-edit-split">
            <div className="profile-edit-current">
              <div className="info-item">
                <span className="info-label">First Name</span>
                <span className="info-value">{user?.firstName}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Last Name</span>
                <span className="info-value">{user?.lastName}</span>
              </div>
            </div>

            <form onSubmit={handleUpdateProfile} className="profile-edit-form">
              <div className="form-group">
                <label>First Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                  placeholder="Enter first name"
                />
              </div>

              <div className="form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  className="form-input"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                  placeholder="Enter last name"
                />
              </div>

              <div className="form-buttons">
                <button type="submit" className="btn btn-success">
                  <TbDeviceFloppy /> Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
